import { render, staticRenderFns } from "./modalAnularRegistro.vue?vue&type=template&id=79287720&"
import script from "./modalAnularRegistro.vue?vue&type=script&lang=js&"
export * from "./modalAnularRegistro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports